import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Card } from "reactstrap";
import bannerImg from "../../assets/images/bannerImg1.jpg";
import icon1 from "../../assets/images/computer.svg";
import icon2 from "../../assets/images/Groupe 76099.svg";
import icon3 from "../../assets/images/shipping box v1.svg";
import icon4 from "../../assets/images/Tracé 27020.svg";
import icon5 from "../../assets/images/icone phone.svg";
import icon6 from "../../assets/images/email.svg";
import { useTranslation } from "react-i18next";
import { BACKEND_URL_PORTAIL } from "../../config/const.js";
import './style.css';
export default function Home() {
  
  const { t } = useTranslation(); // ✅ hook i18n
  document.title = t("HomeQUESSPortail");
  const lang = localStorage.getItem("lang") || "en";

  const icon5Link =
    lang === "fr"
      ? "https://quess360.com/fr/pages/contact"
      : "https://quess360.com/pages/contact";

  const readMoreLink =
    lang === "fr"
      ? "https://quess360.com/fr/pages/our-solutions"
      : "https://quess360.com/pages/our-solutions";

      const readMoreLink2 =
    lang === "fr"
      ? "https://quess360.com/fr/pages/online-courses"
      : "https://quess360.com/pages/online-courses";

      const readMoreLink3 =
    lang === "fr"
      ? "https://quess360.com/fr/pages/solutions"
      : "https://quess360.com/pages/solutions";

 
   const [cardTexts, setCardTexts] = useState({
    0: { fr: "", en: "", isEditing: false },
    2: { fr: "", en: "", isEditing: false },
    3: { fr: "", en: "", isEditing: false },
    4: { fr: "", en: "", isEditing: false },
  });

  const [isAdmin, setIsAdmin] = useState(false);

useEffect(() => {
  const checkRoles = () => {
    try {
      const roles = localStorage.getItem("userRoles");
      if (!roles) {
        setIsAdmin(false);
        return;
      }
      let parsedRoles;
      try {
        parsedRoles = JSON.parse(roles); // format ["admin","user"]
      } catch {
        parsedRoles = roles.split(","); // format "admin,user"
      }
      setIsAdmin(parsedRoles.includes("admin"));
    } catch (e) {
      console.error("Erreur parsing userRoles:", e);
      setIsAdmin(false);
    }
  };

  // Vérifie une première fois
  checkRoles();

  // 1️⃣ Surveille les changements venant d'autres onglets
  window.addEventListener("storage", checkRoles);

  // 2️⃣ Vérifie toutes les 500ms (si ça change dans le même onglet)
  const interval = setInterval(checkRoles, 500);

  return () => {
    window.removeEventListener("storage", checkRoles);
    clearInterval(interval);
  };
}, []);

const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  useEffect(() => {
    axios
      .get(BACKEND_URL_PORTAIL + "api/getAllTextCard", config)
      .then((res) => {
        if (Array.isArray(res)) {
          const newTexts = { ...cardTexts };
          res.forEach((item) => {
            if (newTexts[item.id] !== undefined) {
              newTexts[item.id] = {
                fr: item.french_translation || "",
                en: item.english_translation || "",
                isEditing: false,
              };
            }
          });
          setCardTexts(newTexts);
        }
      })
      .catch((err) => console.error(err));
  }, []);

 const toggleEdit = (id) => {
    setCardTexts((prev) => ({
      ...prev,
      [id]: { ...prev[id], isEditing: !prev[id].isEditing },
    }));
  };
  const handleChange = (id, langKey, value) => {
    setCardTexts((prev) => ({
      ...prev,
      [id]: { ...prev[id], [langKey]: value },
    }));
  };
const renderCardContent = (id) => {
    const text = lang === "fr" ? cardTexts[id]?.fr : cardTexts[id]?.en;
    const { isEditing, fr, en } = cardTexts[id] || {};

    return (
      <div className="card-body">
        {isEditing ? (
          <>
            <label style={{color:"rgb(111, 112, 112)"}}>Texte Français :</label>
            <textarea
              value={fr}
              onChange={(e) => handleChange(id, "fr", e.target.value)}
              rows="3"
              style={{ width: "100%", padding: "8px", marginBottom: "8px" }}
            />
            <label style={{color:"rgb(111, 112, 112)"}}>English Text :</label>
            <textarea
              value={en}
              onChange={(e) => handleChange(id, "en", e.target.value)}
              rows="3"
              style={{ width: "100%", padding: "8px" }}
            />
          </>
        ) : (
          <p>{text}</p>
        )}
      </div>
    );
  };
const renderCardFooter = (id, readMoreLink) => {
  const { isEditing } = cardTexts[id] || {};
  
  // 🔹 Cas spécial pour What's New (id=0)
  if (id === 0) {
    return isAdmin ? (
      <div className="card-footer">
        {isEditing ? (
          <h5
            onClick={() => handleSave(id)}
            style={{ fontSize: "15px", cursor: "pointer", color: "#6F7070",fontWeight: "bold" }}
          >
            {t("save")}
          </h5>
        ) : (
          <h5
            onClick={() => toggleEdit(id)}
            style={{ fontSize: "15px", cursor: "pointer", color: "#6F7070",fontWeight: "bold" }}
          >
            {t("edit")}
          </h5>
        )}
      </div>
    ) : null; // ✅ rien du tout si !isAdmin
  }

  // 🔹 Pour les autres cards (2, 3, 4)
  return (
    <div className="card-footer">
      {isAdmin ? (
        isEditing ? (
          <h5
            onClick={() => handleSave(id)}
            style={{ fontSize: "15px", cursor: "pointer", color: "#6F7070",fontWeight: "bold" }}
          >
            {t("save")}
          </h5>
        ) : (
          <h5
            onClick={() => toggleEdit(id)}
            style={{ fontSize: "15px", cursor: "pointer", color: "#6F7070",fontWeight: "bold" }}
          >
            {t("edit")}
          </h5>
        )
      ) : (
        <a href={readMoreLink} target="_blank" rel="noopener noreferrer">
          {t("readMore")}
        </a>
      )}
    </div>
  );
};


  const handleSave = (id) => {
  axios
    .post(
      BACKEND_URL_PORTAIL + "api/notification/updateText",
      {
        id: id,
        textFr: cardTexts[id]?.fr,
        textEn: cardTexts[id]?.en,
      },
      config
    )
    .then((res) => {
      // ✅ mettre à jour le state local avec la réponse du backend
      setCardTexts((prev) => ({
        ...prev,
        [id]: {
          fr: res.french_translation,
          en: res.english_translation,
          isEditing: false, // ✅ on sort du mode édition
        },
      }));
    })
    .catch((err) => console.error(err));
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Card className="custom-card">
            <div className="page">
              {/* HEADER */}
              <header
                className="hero"
                 style={{
                  backgroundImage: `url(${bannerImg})`,
                 
                }}
              >
                <div className="actions">
                  {/* <a href="tel:18778225051">
                    <img src={icon5} alt="Appeler" />
                  </a> */}
                  <a href={icon5Link} target="_blank" rel="noopener noreferrer">
                    <img src={icon6} alt="Programme Quess 360" />
                  </a>
                </div>
                <div  className="welcome-container">                 
                    <h1 className="textWelcome">{t("welcome")}</h1>
                </div>
              </header>

              {/* CONTENT */}
              <main className="cards">
                {/* CARD 1 */}
                <article className="card-home card-home--blue">
                  <div className="card-header">
                    <h3>{t("softwareSolutions")}</h3>
                    <img className="card-icon" src={icon1} alt="Software" />
                  </div>
                  {renderCardContent(2)}
                  {renderCardFooter(2, readMoreLink)}
                </article>

                {/* CARD 2 */}
                <article className="card-home card-home--cyan">
                  <div className="card-header">
                    <h3>{t("trainingAssessments")}</h3>
                    <img className="card-icon" src={icon2} alt="Training" />
                  </div>
                  {renderCardContent(3)}
                  {renderCardFooter(3, readMoreLink2)}
                </article>

                {/* CARD 3 */}
                <article className="card-home card-home--teal">
                  <div className="card-header">
                    <h3>{t("samplingKit")}</h3>
                    <img className="card-icon" src={icon3} alt="Lab" />
                  </div>
                  {renderCardContent(4)}
                  {renderCardFooter(4, readMoreLink3)}
                </article>

                 {/* CARD What's new (édition FR + EN) */}
                <article className="card-home card-home--blu">
                  <div className="card-header">
                    <h3>{t("whatsNew")}</h3>
                    <img className="card-icon" src={icon4} alt="Lab" />
                  </div>
                  {renderCardContent(0)}
                  {renderCardFooter(0, readMoreLink)}

                </article>
              </main>
            </div>
          </Card>
        </Container>
      </div>
     
    </React.Fragment>
  );
}


